import React, { useEffect, useState} from "react";
import { 
  Container,
  Stack,
  Grid,
  UserListToolbar,
  Button,
  useMediaQuery,
  Card,
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Switch,
  Avatar,
  Divider,
  Fade,
  Zoom,
  Tooltip,
  Chip
} from "@mui/material";
import WOW from "wowjs";
import { GetAll, apiURL, Put } from "../../../utils/apiCalls";
import PropTypes from "prop-types";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { toast } from "react-toastify";
import { margin } from "@mui/system";
import { useNavigate } from 'react-router-dom';
import Iconify from '../../../layouts/Iconify';
import { 
  LocalOffer,
  Add,
  ExpandMore,
  ExpandLess,
  Image,
  ToggleOn,
  ToggleOff,
  Business,
  LocationOn,
  Category,
  Visibility
} from '@mui/icons-material';
const label = { inputProps: { "aria-label": "Switch demo" } };

function Row(props) {
  const { row, togglechange } = props;
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');
  
  return (
    <React.Fragment>
      <TableRow 
        sx={{ 
          "& > *": { borderBottom: "unset" },
          '&:hover': {
            backgroundColor: '#f8f9fa',
            transform: 'translateY(-1px)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          },
          transition: 'all 0.2s ease-in-out'
        }}
      >
        <TableCell>
          <Tooltip title={open ? "Collapse" : "Expand"}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
              sx={{
                background: '#1976d2',
                color: 'white',
                borderRadius: 1,
                width: 24,
                height: 24,
                '&:hover': {
                  background: '#1565c0',
                  transform: 'scale(1.1)'
                },
                transition: 'all 0.2s ease-in-out'
              }}
            >
              {open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell component="th" scope="row">
          <Chip 
            label={`#${row.id}`} 
            size="small" 
            sx={{ 
              background: '#e3f2fd', 
              color: '#1976d2',
              fontWeight: 600
            }} 
          />
        </TableCell>
        <TableCell align="right">
          <Stack direction="row" alignItems="center" spacing={1} justifyContent="flex-end">
            <Business sx={{ fontSize: 14, color: '#666' }} />
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              {row?.name}
            </Typography>
          </Stack>
        </TableCell>
        <TableCell align="right">
          <Stack direction="row" alignItems="center" spacing={1} justifyContent="flex-end">
            <LocationOn sx={{ fontSize: 14, color: '#666' }} />
            <Typography variant="body2" sx={{ color: '#666' }}>
              {row?.place}
            </Typography>
          </Stack>
        </TableCell>
        <TableCell align="right">
          <Chip 
            label={row?.type} 
            size="small" 
            sx={{ 
              background: '#f3e5f5', 
              color: '#7b1fa2',
              fontWeight: 500
            }} 
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ 
              margin: 1,
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
              borderRadius: 2,
              p: 2
            }}>
              <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
                <Avatar sx={{ background: '#1976d2', width: 28, height: 28 }}>
                  <LocalOffer sx={{ fontSize: 16, color: 'white' }} />
                </Avatar>
                <Typography variant="h6" sx={{ color: '#333', fontWeight: 600 }}>
                  Project Offers
              </Typography>
                <Chip 
                  label={`${row?.offer_banners?.length || 0} offers`} 
                  size="small" 
                  sx={{ 
                    background: '#e8f5e8', 
                    color: '#2e7d32',
                    fontWeight: 500
                  }} 
                />
              </Stack>
              
              {row?.offer_banners?.length > 0 ? (
                <Table size="small" aria-label="offers">
                <TableHead>
                    <TableRow sx={{ background: 'rgba(25, 118, 210, 0.05)' }}>
                      <TableCell sx={{ fontWeight: 600, color: '#333' }}>ID</TableCell>
                      <TableCell sx={{ fontWeight: 600, color: '#333' }}>Image</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 600, color: '#333' }}>Type</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 600, color: '#333' }}>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {row?.offer_banners?.map((historyRow) => (
                      <TableRow 
                        key={historyRow.date}
                        sx={{
                          '&:hover': {
                            backgroundColor: 'rgba(25, 118, 210, 0.04)'
                          }
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <Chip 
                            label={`#${historyRow?.id}`} 
                            size="small" 
                            sx={{ 
                              background: '#e3f2fd', 
                              color: '#1976d2',
                              fontWeight: 500
                            }} 
                          />
                        </TableCell>
                        <TableCell>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Image sx={{ fontSize: 14, color: '#666' }} />
                            <Tooltip title="View Image">
                              <a 
                                href={historyRow?.offer_docs[0]?.filepaths3} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{ 
                                  color: '#1976d2', 
                                  textDecoration: 'none',
                                  fontSize: '0.875rem'
                                }}
                              >
                                View Image
                              </a>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                        <TableCell align="center">
                          <Chip 
                            label={historyRow?.type} 
                            size="small" 
                            sx={{ 
                              background: '#f3e5f5', 
                              color: '#7b1fa2',
                              fontWeight: 500
                            }} 
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Stack direction="row" alignItems="center" spacing={1} justifyContent="center">
                            {historyRow?.active ? (
                              <ToggleOn sx={{ color: '#4caf50', fontSize: 20 }} />
                            ) : (
                              <ToggleOff sx={{ color: '#f44336', fontSize: 20 }} />
                            )}
                          <Switch
                            checked={historyRow?.active}
                            onChange={(e) => {
                              togglechange(e, historyRow?.id);
                            }}
                              sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': {
                                  color: '#4caf50',
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                  backgroundColor: '#4caf50',
                                },
                              }}
                            />
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              ) : (
                <Box sx={{ 
                  textAlign: "center", 
                  py: 4,
                  background: 'white',
                  borderRadius: 2,
                  border: '2px dashed #e0e0e0'
                }}>
                  <Avatar sx={{ 
                    background: '#f5f5f5', 
                    width: 40, 
                    height: 40, 
                    mx: 'auto', 
                    mb: 2 
                  }}>
                    <LocalOffer sx={{ fontSize: 20, color: '#999' }} />
                  </Avatar>
                  <Typography variant="body1" sx={{ color: '#666', fontWeight: 500 }}>
                    No offers available for this project
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#999', mt: 1 }}>
                    Create offers to showcase this project
                  </Typography>
                </Box>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const Offers = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');

  const togglechange = async (e, id) => {
    const response = await Put(apiURL + "/api/v1/offer_banner/", id, {
      active: e.target.checked,
    });
    if (response && response.data && response.data.status) {
      getProjects();
    }
  };
  const getProjects = async () => {
    const response = await GetAll(apiURL + "/api/v1/projects");
    if (response && response.data && response.data.status) {
      setData(response.data.data);
      console.log(response.data.data);
    }
  };
  useEffect(() => {
    getProjects();
  }, []);

  return (
    <Container sx={{ m: 0, width: "100%", maxWidth: "100%" }} maxWidth={false}>
      {/* Professional Header Section */}
      <Fade in timeout={800}>
        <Box sx={{ mb: 4 }}>
          <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 3 }}>
            <Avatar sx={{ 
              bgcolor: '#1976d2', 
              width: 48, 
              height: 48,
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
            }}>
              <LocalOffer sx={{ fontSize: 24, color: 'white' }} />
            </Avatar>
            <Box>
              <Typography variant="h5" component="h1" fontWeight="bold" color="text.primary">
                Project Offers Management
              </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                Manage and control project offers and promotional banners
              </Typography>
            </Box>
          </Stack>
          <Divider sx={{ my: 2 }} />
        </Box>
      </Fade>

      <Zoom in timeout={600}>
        <Card sx={{ 
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          borderRadius: 3,
          overflow: 'hidden'
        }}>
          {/* Enhanced Toolbar Section */}
          <Paper
            elevation={0}
            sx={{
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
              p: 2,
              borderBottom: '1px solid #e0e0e0'
            }}
          >
            <Grid container spacing={1} alignItems="center">
  <Grid item xs={12} sm={6} lg={6} md={6} xl={6}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Avatar
                    sx={{
                      width: 32,
                      height: 32,
                      background: '#1976d2'
                    }}
                  >
                    <Business sx={{ fontSize: 16, color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle1" sx={{ color: '#333', fontWeight: 600 }}>
                      Project Overview
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.75rem' }}>
                      {data.length} projects with offer management
          </Typography>
                  </Box>
                </Stack>
</Grid>
<Grid item xs={12} sm={6} lg={6} md={6} xl={6} sx={{justifyContent: isMobile ? 'center' : 'flex-end', alignItems:'center', display:'flex' }}>
                <Button 
                  variant='contained' 
                  onClick={()=> navigate('/dashboard/offers/create')} 
                  sx={{
                    height: 'max-content', 
                    marginRight: '24px !important', 
                    marginBottom:'15px !important', 
                    width: isMobile ? '80%': 'max-content',
                    background: '#1976d2',
                    '&:hover': {
                      background: '#1565c0'
                    },
                    borderRadius: 2,
                    px: 2,
                    py: 1,
                    fontSize: '0.875rem'
                  }}
                  startIcon={<Add sx={{ fontSize: 16 }} />}
                >
                  Create Offer
                </Button>
          </Grid>
          </Grid>    
          </Paper>

          <TableContainer component={Paper} elevation={0}>
        <Table aria-label="collapsible table">
          <TableHead>
                <TableRow sx={{ background: 'rgba(25, 118, 210, 0.05)' }}>
                  <TableCell sx={{ fontWeight: 600, color: '#333' }}>Actions</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#333' }}>Project ID</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600, color: '#333' }}>Project Name</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600, color: '#333' }}>Location</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600, color: '#333' }}>Type</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row) => (
              <Row key={row?.name} row={row} togglechange={togglechange} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </Card>
      </Zoom>

      {/* Professional Stats Footer */}
      <Fade in timeout={1000}>
        <Paper
          elevation={0}
          sx={{
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            borderRadius: 3,
            p: 3,
            mt: 3,
            border: '1px solid #e0e0e0'
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Avatar
                  sx={{
                    width: 40,
                    height: 40,
                    background: '#1976d2'
                  }}
                >
                  <Business sx={{ fontSize: 20, color: 'white' }} />
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ color: '#333', fontWeight: 700 }}>
                    Total Projects
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666' }}>
                    {data.length} active projects
                  </Typography>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Avatar
                  sx={{
                    width: 40,
                    height: 40,
                    background: '#4caf50'
                  }}
                >
                  <LocalOffer sx={{ fontSize: 20, color: 'white' }} />
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ color: '#333', fontWeight: 700 }}>
                    Total Offers
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666' }}>
                    {data.reduce((total, project) => total + (project.offer_banners?.length || 0), 0)} promotional offers
                  </Typography>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Avatar
                  sx={{
                    width: 40,
                    height: 40,
                    background: '#ff9800'
                  }}
                >
                  <ToggleOn sx={{ fontSize: 20, color: 'white' }} />
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ color: '#333', fontWeight: 700 }}>
                    Active Offers
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666' }}>
                    {data.reduce((total, project) => {
                      return total + (project.offer_banners?.filter(offer => offer.active)?.length || 0);
                    }, 0)} currently active
                  </Typography>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Paper>
      </Fade>
    </Container>
  );
};
export default Offers;
